<template>
  <footer class="cfoot">
    <div class="cfoot-inner">
      <p class="copyright">© {{ year }} Copyright</p>

      <nav aria-label="Informations">
        <ul>
          <li><router-link to="/legal">Légal</router-link></li>
          <li><router-link to="/who">Informations</router-link></li>
          <li><router-link to="/tarification">Tarif</router-link></li>
          <li><router-link to="/assistance">Assistance</router-link></li>
        </ul>
      </nav>

      <p class="note">Made with pep<span class="peps">s</span> by <a :href="siteUrl">Citron Digital</a></p>
    </div>
  </footer>
</template>

<script>
  import {SITE_URL} from "@/components/public/siteLinks";

  /**
   * Pied de page de l'application : une seule ligne basse, dans le style du site (bande citron, liens soulignés surlignés au survol).
   */
  export default {
    name: 'CustomFooter',
    props: ['logo_img', 'link_routes', 'user_routes'],
    data: function() {
      return {
        year: new Date().getFullYear(),
        siteUrl: SITE_URL
      };
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  @require '~/src/common/style/public.styl';

  .cfoot
    flex none
    box-sizing border-box
    width 100%
    height PUB_FOOTER_HEIGHT
    background-color PUB_BAR
    border-top 3px solid PUB_LEMON
    color PUB_WHITE
    font-family PUB_FONT_TEXT
    font-size 0.9rem

  .cfoot-inner
    display flex
    align-items center
    justify-content center
    height 100%
    max-width 1280px
    margin 0 auto
    padding 0 clamp(12px, 3vw, 28px)

  p
    margin 0
    color PUB_ON_BAR
    font-family PUB_FONT_TEXT

  nav ul
    display flex
    flex-wrap wrap
    justify-content center
    gap 0 22px
    margin 0
    padding 0
    list-style none
  nav li
    margin 0
    padding 0

  a
    color PUB_WHITE
    font-family PUB_FONT_TEXT
    font-weight 600
    text-decoration none
    transition background-color 0.15s ease
    &:hover, &:focus-visible
      background-color PUB_LEMON
      color PUB_INK

  .note a
    font-weight 700

  .peps
    color PUB_LEMON

  .copyright, .note
    display none

  @media only screen and (min-width: TABLET_SIZE)
    .cfoot-inner
      justify-content space-between
    .copyright, .note
      display block
      flex 1 1 0
    .note
      text-align right
</style>
